

export const Routes = {
  // pages
  //Presentation: { path: "/" },
  DashboardOverview: { path: "/" },
  Transactions: { path: "/transactions" },
  Settings: { path: "/settings" },
  Upgrade: { path: "/upgrade" },
  BootstrapTables: { path: "/tables/bootstrap-tables" },
  AccessControlTabs: { path: "/master/access-control" },
  CustomerEntryReports: { path: "/master/customer-entry-report" },
  CustomerEntry: { path: "/master/customer-entry" },
  DealerEntryReports: { path: "/master/dealer-entry-report" },
  DealerEntry: { path: "/master/dealer-entry" },
  UserEntryReports: { path: "/master/user-entry-report" },
  UserEntry: { path: "/master/user-entry" },
  AboutUs: { path: "/about" },

  // --- production
  ProductionList: { path: "/productionx/production-list" },
  AddProduction: { path: "/productionx/add-production" },

  // --- dispatch
  DispatchList: { path: "/dispatchx/dispatch-list" },
  AddDispatch: { path: "/dispatchx/add-dispatch" },

  // --- work order
  FieldJobList: { path: "/Work-Orderx/field-job-list" },
  FieldJob: { path: "/Work-Orderx/field-job" },
  InstallationList: { path: "/Work-Orderx/installation-list" },
  Installation: { path: "/Work-Orderx/installation" },
  CalibrationList: { path: "/Work-Orderx/calibration-list" },
  Calibration: { path: "/Work-Orderx/calibration" },  

  // --- services
  ListofFieldIssue: { path: "/serviceModule/field-job-list" },
  ListOfInstallation: { path: "/serviceModule/installation-list" },
  ListOfCalibration: { path: "/serviceModule/calibration-list" },
  VerificationInstallationList: { path: "/serviceModule/verification-installation-list" },
  VerificationCalibrationList: { path: "/serviceModule/verification-calibration-list" },
  VerificationFieldIssueList: { path: "/serviceModule/verification-fieldIssue-list" },
  ArkFieldList: { path: "/serviceModule/ark-field-list" },
  ArkCalibrationList: { path: "/serviceModule/ark-calibration-list" },
  ARKFailedCalibrationList: { path: "/serviceModule/ark-failed-calibration-list" },
  GetDispenser: { path: "/serviceModule/installation" },
  GetCalibrationDispenser: { path: "/serviceModule/calibration" },
  GetFieldDispenser: { path: "/serviceModule/field-job" },
  EndingARKCalibration: { path: "/serviceModule/ending-ark-calibration" },
  NonTechDashboard: { path: "/NonTechDashboard" },
  TechDashboard: { path: "/TechDashboard" },
  TicketServiceNonTech: { path: "/Callcenter/TicketServiceNonTech" },
  RaiseTicketForm: { path: "/Callcenter/RaiseTicketForm" },
  TicketServiceTech: { path: "/Callcenter/TicketServiceTech" },
   RoOnboarding: { path: "/Callcenter/ROCreate" },
  RoList: { path: "/Callcenter/RoGetlist" },

  // --- reports
  AllReportsTab: { path: "/reports/master-record" },
  DispatchWiseTab: { path: "/reports/dispatch-record" },
  WorkOrderTab: { path: "/reports/work-order-record" },
  ProductTab: { path: "/reports/productTab" },
  ServicesTab: { path: "/reports/services-record" },
  DispenserRecordTab: { path: "/reports/dispenser-record" },
  Billing: { path: "/examples/billing" },
  Invoice: { path: "/examples/invoice" },

  // --- auth
  Signin: { path: "/sign-in" },
  SignMobile: { path: "/sign-mobile" },
  ForgotPassword: { path: "/forgot-password" },
  ResetPassword: { path: "/reset-password/:token" },
  SignOtp: { path: "/sign-otp" },
  NotFound: { path: "/404" },
  ServerError: { path: "/500" },
// sales tool
  Configutar: { path: "/mainqoute/configutar" },
  salesComponent: { path: "/mainqoute/SalesAddComponent/AddComponent" },
  Approvedcomp: { path: "/mainqoute/Approvedcomp" },
  Underapprovedcomp: { path: "/mainqoute/Underapprovedcomp" },
  Draftcomp: { path: "/mainqoute/Draftcomp" },
CustomerComp: {path:"/funnel/CustomerComp"},
StatusComp:{path:"/funnel/StatusComp"},
  Opencomp:{path:"/task/Opencomp"},
  ToAssignComp:{path:"/task/ToAssignComp"},

  // Employee Activity Tracker
  EmployeeActivityTracker: { path: "/activity-tracker" },
  EmployeeActivityDashboard: { path: "/activity-tracker/dashboard" },
  EmployeeAttendanceHistory: { path: "/activity-tracker/attendance" },
  EmployeeActivityLogs: { path: "/activity-tracker/logs" },
  EmployeeBreakHistory: { path: "/activity-tracker/breaks" },
  EmployeeTasks: { path: "/activity-tracker/tasks" },
  ManagerAnalytics: { path: "/activity-tracker/manager" },
};

